export default __webpack_public_path__ + "static/media/27.5b03fb89.jpg";